import React, { useEffect, useMemo } from 'react';
import { i18n } from '../i18n';
import { log } from '../lib/logger';
import { captureException } from '../lib/sentry';
import { ReportErrorsToSentry } from './ReportErrorsToSentry';
import { ApolloProvider } from '@apollo/client';
import { LoginConfirmationDialog } from './LoginConfirmationDialog';
import { createAuthenticatedClient } from '../graphql/graphqlClient';
import { useToken } from '../hooks/useToken';
import { login } from '../graphql/authentication';
import { ChatController } from '../controllers/ChatController';
import { FullscreenImageController } from '../controllers/FullscreenImageController';
import styled from 'styled-components';
import { QueryClientProvider } from '@tanstack/react-query';
import { usePagesVisited } from '../hooks/usePagesVisited';
import { queryClient } from '../stores/queryClient';
const TopLevelWrapper = styled.span `
  --pt-minimize-bottom: 1rem;
  --pt-chatbox-right: 4rem;
  --pt-chatbox-bottom: calc(
    var(--pt-minimize-bottom) + /* IconButton size: */ 48px + /* margin: */ 1rem
  );
`;
const pillowTalkDefaultContext = {
    clientId: undefined,
    lineOfBusiness: undefined,
    redirectUri: undefined,
};
export const PillowTalkContext = React.createContext(pillowTalkDefaultContext);
const ChatTopLevelWrapper = ({ className, conversation, }) => {
    usePagesVisited(conversation.conversationParams.lineOfBusiness);
    useEffect(() => {
        i18n.changeLanguage(conversation.conversationParams.language).catch(err => {
            log.error(err);
            captureException(err);
        });
    }, [conversation.conversationParams.language]);
    const { token } = useToken(conversation.conversationParams.clientId);
    const apolloClient = useMemo(() => createAuthenticatedClient(conversation.conversationParams.lineOfBusiness, token), [conversation.conversationParams.lineOfBusiness, token]);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(LoginConfirmationDialog, { onLogin: () => login(conversation.conversationParams.clientId, conversation.conversationParams.redirectUri) }),
        React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(PillowTalkContext.Provider, { value: {
                    lineOfBusiness: conversation.conversationParams.lineOfBusiness,
                    clientId: conversation.conversationParams.clientId,
                    redirectUri: conversation.conversationParams.redirectUri,
                } },
                React.createElement(TopLevelWrapper, { className: className },
                    React.createElement(ChatController, null),
                    React.createElement(FullscreenImageController, null))))));
};
export const Chat = ({ className, conversation }) => {
    return (React.createElement(ReportErrorsToSentry, null,
        React.createElement(ChatTopLevelWrapper, { className: className, conversation: conversation })));
};
//# sourceMappingURL=Chat.js.map